export const NAV_ITEMS = [
  { id: 'home', label: 'Home', href: '#home' },
  { id: 'about', label: 'About', href: '#about' },
  { id: 'skills', label: 'Skills', href: '#skills' },
  { id: 'projects', label: 'Projects', href: '#projects' },
  { id: 'experience', label: 'Experience', href: '#experience' },
  { id: 'contact', label: 'Contact', href: '#contact' },
];

export const CRYPTO_SYMBOLS = [
  {
    symbol: '₿',
    name: 'Bitcoin',
    color: '#f7931a',
    icon: 'fa-brands fa-bitcoin'
  },
  {
    symbol: 'Ξ',
    name: 'Ethereum',
    color: '#627eea',
    icon: 'fa-brands fa-ethereum'
  },
  {
    symbol: '◎',
    name: 'Solana',
    color: '#9945ff',
    // Font Awesome doesn't provide a Solana brand icon; fallback will use symbol
    icon: ''
  },
  {
    symbol: 'BNB',
    name: 'Binance Coin',
    color: '#f3ba2f',
    // Use the Binance brand if available, otherwise the text symbol will render
    icon: 'fa-brands fa-binance'
  }
];

export const SOCIAL_LINKS = [
  { id: '1', name: 'GitHub', url: 'https://github.com/yourusername', icon: 'fab fa-github' },
  { id: '2', name: 'LinkedIn', url: 'https://linkedin.com/in/yourprofile', icon: 'fab fa-linkedin' },
  { id: '3', name: 'Twitter', url: 'https://twitter.com/yourtwitter', icon: 'fab fa-twitter' },
  { id: '4', name: 'Discord', url: 'https://discord.com/invite/yourdiscord', icon: 'fab fa-discord' }
];

export const CONTACT_METHODS = [
  { id: '1', name: 'Email', url: 'mailto:your.email@example.com', icon: 'fas fa-envelope' },
  { id: '2', name: 'LinkedIn', url: 'https://linkedin.com/in/yourprofile', icon: 'fab fa-linkedin' },
  { id: '3', name: 'GitHub', url: 'https://github.com/yourusername', icon: 'fab fa-github' },
  { id: '4', name: 'Twitter', url: 'https://twitter.com/yourtwitter', icon: 'fab fa-twitter' }
];

export const COLORS = {
  primary: '#00d4ff',
  secondary: '#ffd700',
  accent: '#8a2be2',
  success: '#00ff88',
  error: '#ff6b6b',
  warning: '#ffaa00',
  text: '#ffffff',
  textSecondary: '#cccccc',
  textMuted: '#aaaaaa',
  background: '#0a0a0a',
  backgroundSecondary: '#1a1a2e',
  backgroundTertiary: '#16213e'
} as const;

